const adminViewUrls = new Set<string>();

export function markAdminViewUrl(url: string) {
  adminViewUrls.add(url);
}

export function isAdminViewUrl(url: string) {
  return adminViewUrls.has(url);
}

// The last URL visited outside any admin view — where its back button
// returns to. Null until the user has visited a non-admin page (deep links).
let adminViewReturnUrl: string | null = null;

export function rememberAdminViewReturnUrl(url: string) {
  adminViewReturnUrl = url;
}

export function getAdminViewReturnUrl() {
  return adminViewReturnUrl;
}
